import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/Service/common.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { Level1Model, ProductSeries, VariantLevel4 } from 'src/app/Model/ProductModel';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from 'src/app/app.global';
import { Title } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { AccessPermissionModel } from 'src/app/Model/WorkFlowScreenAccessModel';
import { AccessPermissionService } from 'src/app/Service/access-permission.service';

@Component({
  selector: 'app-variant-level4-details',
  templateUrl: './variant-level4-details.component.html',
  styleUrls: ['./variant-level4-details.component.scss']
})
export class VariantLevel4DetailsComponent implements OnInit {
  displayedColumns: string[] = ['SeriesName', 'ModelName', 'Level1Name', 'Level2Name', 'Level3', 'Level3Price', 'otherType', 'Level4', 'Level4Price', 'Action'];
  dataSource: MatTableDataSource<VariantLevel4>;
  disabled: boolean = false;
  SeriesName: string = "";
  isVariant2DependsOnVariant1: boolean = false;
  isVariant3DependsOnVariant2: boolean = false;
  isVariant4DependsOnVariant3: boolean = false;
  accesspermissionobj:AccessPermissionModel[]=Array<AccessPermissionModel>();
  AccesspermissionForRole:any[]=[];

  /*************************************************************************
        Server side Pagination purpose
    *************************************************************************/
  pageNumber: number = 1;
  @Input() pageSize: number = 5;
  @Input() length: number;
  @Input() pageIndex: number = this.pageNumber - 1;
  direction: string = 'desc';
  ColumnName: string = 'ModifiedOn';
  SearchText: string = "";
  @Output('matSortChange') sortChange: EventEmitter<Sort>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  /*************************************************************************
     End here
  *************************************************************************/

  ProductSeriesVariant4Label: string = '';
  ProductSeriesVariant3Label: string = '';
  ProductSeriesVariant1Label: string = '';
  ProductSeriesVariant2Label: string = '';
  ProductSeriesId: number;
  showLoader: boolean;
  data: any[] = [];
  ProductSeriesArr: ProductSeries = new ProductSeries();
  VariantDrpdown: string = "";
  UserRole: any;
  isProductVariant4Editable: boolean = false;
  constructor(private toastr: ToastrService, private CommonService: CommonService, public dialog: MatDialog, private router: Router, private route: ActivatedRoute, private titleService: Title,private accessservice: AccessPermissionService
    ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.titleService.setTitle(this.route.snapshot.data['title'] + " - WEISS");
    this.UserRole = localStorage.getItem("UserRole");
    this.getAccess();
   //this.isProductVariant4Editable = AppGlobals.ProductMastersEditableAccessArray.filter(x => x.role == this.UserRole)[0]?.isEditable;
    this.route.params.subscribe(params => {
      this.ProductSeriesVariant3Label = params['Variant3'];
      this.ProductSeriesVariant4Label = params['Variant4'];
      this.ProductSeriesId = params['Seriesid'];
      this.pageSize = 5;
      this.pageNumber = 1;
      this.pageIndex = this.pageNumber - 1;
      this.length = 0;
      this.direction = 'desc';
      this.ColumnName = 'ModifiedOn';
      this.SearchText = "";
      this.VariantDrpdown = "Variant4";
      this.GetAllVariantLevel4Details();
      this.getAllProductSeries();
    });


  }


  /*************************************************************************
   * Below function used for Server side Pagination,Sorting and Searching
   * (1)GetAllVariantLevel4Details() - To get data for grid
   * (2)SearchParam() -  searching
   * (3)sortData() - Sorting
   * (4)pageEvent() - Pagination
   * 
   * ***********************************************************************/

  GetAllVariantLevel4Details() {
    this.showLoader = true;
    let queryString = "";
    queryString = "pageNumber=" + this.pageNumber;
    queryString += "&pageSize=" + this.pageSize;
    queryString += "&searchText=" + this.SearchText;
    queryString += "&direction=" + this.direction;
    queryString += "&columnName=" + this.ColumnName;
    queryString += "&ProductSeriesId=" + this.ProductSeriesId; //Seires Id

    this.CommonService.GetData('ProductVariantLevel4', 'GetAllPagination', queryString).subscribe((data: any) => {
      this.data = data.Data;
      this.length = data.Total;
      if (this.ColumnName == 'Level3Price') {
        var IsPriceOnRequestList: VariantLevel4[] = [];
        var IsNotPriceOnRequestList: VariantLevel4[] = [];

        IsPriceOnRequestList = this.data.filter(x => x.Level3IsPriceOnRequest == true);
        IsNotPriceOnRequestList = this.data.filter(x => x.Level3IsPriceOnRequest != true);
        IsPriceOnRequestList = IsPriceOnRequestList.concat(IsNotPriceOnRequestList);
        this.dataSource = new MatTableDataSource(IsPriceOnRequestList);
      }
      else if (this.ColumnName == 'Level4Price') {
        var IsPriceOnRequestList: VariantLevel4[] = [];
        var IsNotPriceOnRequestList: VariantLevel4[] = [];

        IsPriceOnRequestList = this.data.filter(x => x.IsPriceOnRequest == true);
        IsNotPriceOnRequestList = this.data.filter(x => x.IsPriceOnRequest != true);
        IsPriceOnRequestList = IsPriceOnRequestList.concat(IsNotPriceOnRequestList);
        this.dataSource = new MatTableDataSource(IsPriceOnRequestList);
      }
      else {
        this.dataSource = new MatTableDataSource(this.data);
      }
      this.showLoader = false;
    }, error => {
      this.toastr.error("Failed to load data!");
      this.showLoader = false;
    });

  }

  getAllProductSeries() {
    this.showLoader = true;

    let queryString = "";
    queryString = "Id=" + this.ProductSeriesId;

    this.CommonService.GetData("ProductSeries", "GetById", queryString).subscribe((data: any) => {
      this.ProductSeriesArr = data;
      this.SeriesName = data.SeriesName;
      this.isVariant2DependsOnVariant1 = data.IsLevel2DepOnLevel1;
      this.isVariant3DependsOnVariant2 = data.IsLevel3DepOnLevel2;
      this.isVariant4DependsOnVariant3 = data.IsLevel4DepOnLevel3;
      this.ProductSeriesVariant1Label = data.Label_Variant1;
      this.ProductSeriesVariant2Label = data.Label_Variant2;
      this.ProductSeriesVariant3Label = data.Label_Variant3;
      this.ProductSeriesVariant4Label = data.Label_Variant4;
      this.showLoader = false;
    }, error => {
      this.toastr.error("Failed to load data!");
      this.showLoader = false;
    });
  }

  SearchParam(event: any) {
    this.SearchText = event.target.value;
    this.pageNumber = 1;
    this.paginator.pageIndex = 0;
    this.GetAllVariantLevel4Details();
  }

  sortData(event: any) {
    if (this.dataSource.filteredData != null) {
      this.direction = event.direction;
      this.ColumnName = event.active;
      this.GetAllVariantLevel4Details();
    }
  }

  pageEvent(event: any) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.GetAllVariantLevel4Details();
  }
  /************************************************************************
   * Grid Code End 
   * **********************************************************************/

  /*******************************************************************************
  * Form validation method
  * ******************************************************************************/

  AvoidSpace(event: any) {
    if (event.which === 32 && !event.target.value.length) {
      event.preventDefault();
    }
  }

  /*******************************************************************************
   * End Form validation method 
   * ******************************************************************************/

  RedirectToVariant(event: any) {
    if (this.VariantDrpdown == 'ProductModel') {
      this.router.navigate(['/ProductModel', this.ProductSeriesArr.Id]);
    }
    else if (this.VariantDrpdown == 'Options') {
      this.router.navigate(['/Options', this.ProductSeriesArr.Id]);
    }
    else if (this.VariantDrpdown == 'Variant1') {
      this.router.navigate(['/VariantLevel1', this.ProductSeriesArr.Id, this.ProductSeriesArr.Label_Variant1]);
    }
    else if (this.VariantDrpdown == 'Variant2') {
      this.router.navigate(['/VariantLevel2', this.ProductSeriesArr.Id, this.ProductSeriesArr.Label_Variant1, this.ProductSeriesArr.Label_Variant2]);
    }
    else if (this.VariantDrpdown == 'Variant3') {
      this.router.navigate(['/VariantLevel3', this.ProductSeriesArr.Id, this.ProductSeriesArr.Label_Variant2, this.ProductSeriesArr.Label_Variant3]);
    }
    else if (this.VariantDrpdown == 'Variant4') {
      this.router.navigate(['/VariantLevel4', this.ProductSeriesArr.Id, this.ProductSeriesArr.Label_Variant3, this.ProductSeriesArr.Label_Variant4]);
    }
  }
  
  UpdateVariantLevel4StatusById(Level4Data: VariantLevel4, CurrentStatus: boolean) {

    if (CurrentStatus == true) {
      //Create ConfirmDialogRef 
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          title: "Are you sure?",
          message: "Do you want to deactivate this " + this.ProductSeriesVariant4Label + ' ?',
        }
      });
      // listen to response from ConfirmDialogRef
      dialogRef.afterClosed().subscribe(dialogResult => {
        // if user pressed yes dialogResult will be true, 
        // if he pressed no - it will be false
        if (dialogResult) {
          this.pageNumber = 1;
          this.paginator.pageIndex = 0;
          this.length = 0;
          this.direction = 'desc';
          this.ColumnName = 'ModifiedOn';
          this.showLoader = true;
          this.CommonService.PostData('ProductVariantLevel4', 'UpdateStatus', Level4Data, null).subscribe((data: any) => {
            this.showLoader = false;
            if (data.ResponseCode == 1) {
              this.toastr.success(this.ProductSeriesVariant4Label + " deactivated successfully!");
            }
            else if (data.ResponseCode == 0) {
              this.toastr.warning("Failed to deactivate this " + this.ProductSeriesVariant4Label + " because it has some dependency!");
            }
            else {
              this.toastr.info("Failed to deactivate " + this.ProductSeriesVariant4Label + "!");
            }
            this.GetAllVariantLevel4Details();
          }, error => {
            this.toastr.error("Failed to deactivate " + this.ProductSeriesVariant4Label + "!");
            this.GetAllVariantLevel4Details();
            this.showLoader = false;
          });

        }
        else {
          this.GetAllVariantLevel4Details();
          this.showLoader = false;
          let element: HTMLElement = document.getElementsByClassName('slideToogle')[0] as HTMLElement;

        }
      });

    }
    else {
      //Create ConfirmDialogRef
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          title: "Are you sure?",
          message: "Do you want to activate this " + this.ProductSeriesVariant4Label + "?"
        }
      });
      // listen to response from ConfirmDialogRef
      dialogRef.afterClosed().subscribe(dialogResult => {
        // if user pressed yes dialogResult will be true, 
        // if he pressed no - it will be false
        if (dialogResult) {
          this.pageNumber = 1;
          this.paginator.pageIndex = 0;
          this.length = 0;
          this.direction = 'desc';
          this.ColumnName = 'ModifiedOn';
          this.showLoader = true;

          this.CommonService.PostData('ProductVariantLevel4', 'UpdateStatus', Level4Data, null).subscribe((data: any) => {
            this.showLoader = false;
            if (data.ResponseCode == 1) {
              this.toastr.success(this.ProductSeriesVariant4Label + " activated successfully!");
            }

            else {
              this.toastr.info("Failed to activate " + this.ProductSeriesVariant4Label + "!");
            }
            this.GetAllVariantLevel4Details();
          }, error => {
            this.toastr.error("Failed to activate " + this.ProductSeriesVariant4Label + "!");
            this.GetAllVariantLevel4Details();
            this.showLoader = false;
          });

        }
        else {
          this.GetAllVariantLevel4Details();
          this.showLoader = false;
          let element: HTMLElement = document.getElementsByClassName('slideToogle')[0] as HTMLElement;
          element.click();
        }
      });
    }
  }

  getAccess()
  {
    this.accessservice.GetAll().subscribe((data:any)=> {
      this.accesspermissionobj=data;
      this.isProductVariant4Editable=this.accesspermissionobj.filter(x => x.Fk_RoleId == this.UserRole && x.ElementKey=='isProductLine')[0]?.IsEditable;
      
    });
 
  }
}


